// Story metadata — text is fetched from the backend at runtime (proxied from Project Gutenberg)
export const STORIES = [
  {
    id: "wizard-of-oz",
    title: "The Wonderful Wizard of Oz",
    author: "L. Frank Baum",
    description: "Dorothy and her dog Toto are swept away to the magical land of Oz.",
    emoji: "🌈",
  },
  {
    id: "gift-of-magi",
    title: "The Gift of the Magi",
    author: "O. Henry",
    description: "A couple makes sacrifices for each other in this beloved holiday classic.",
    emoji: "🎁",
  },
  {
    id: "call-of-the-wild",
    title: "The Call of the Wild",
    author: "Jack London",
    description: "Buck, a sled dog in the Yukon, answers the primal call of the wilderness.",
    emoji: "🐺",
  },
  {
    id: "treasure-island",
    title: "Treasure Island",
    author: "Robert Louis Stevenson",
    description: "Jim Hawkins sets sail on a high-seas adventure in search of buried treasure.",
    emoji: "🏴‍☠️",
  },
];
